import $api from "../../../../services/axiosService";
import { getUserHrDocsAction } from "../getUserHrDocs.action";
import RequestServices from "../../../../../frontend.services/RequestServices/RequestServices";

export const getUserHrDocsThunkAction = (props) => async (dispatch) => {
    try {
        const response = await $api("v2/directum/entities/0", { params: { entityType: props.entityType ? props.entityType : 0 } });
        if (response.status === 200) {
            const result = await RequestServices.getHrRequestsWithFile(response.data);
            dispatch(getUserHrDocsAction(result));
        }

    } catch (e) {
        if (props) {
            if (e?.response?.status === 500) {
                props.setErrDescription(e?.response.data.detail);
                props.setErrorModal(true);
            } else {
                if(props.setErrDescription && props.setErrorModal) {
                    props.setErrDescription("Что-то пошло не так, повторите попытку позже.");
                    props.setErrorModal(true);
                }

            }
        } else {
            throw e instanceof Error ? e : new Error(JSON.stringify(e?.response?.data ?? e));
        }
    }
};
